import { DesktopSidebar } from './DesktopSidebar'

/**
 * Desktop layout shell — fixed left sidebar + main content frame. Rendered by
 * the authenticated layout only at desktop widths (>=1024px); the touch
 * (mobile/iPad) layout keeps the BottomNav instead.
 *
 * `<main>` is a full-height frame that does NOT scroll itself — the active
 * screen owns scrolling. Screens designed for desktop wrap their content in
 * `DesktopPage` (max-width + padding + scroll); screens not yet redesigned keep
 * their existing AppLayout (which is `h-full` with its own scroll) and simply
 * fill the frame full-width, mirroring the iPad experience.
 */
export function DesktopShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex h-full overflow-hidden bg-surface-brand-L0">
      <DesktopSidebar />
      <main className="relative flex-1 min-w-0 h-full overflow-hidden">
        {children}
      </main>
    </div>
  )
}
